// utils/getPentestServer.js
// Build pentest server URL from API base and configurable gateway prefix.
// Honors explicit override REACT_APP_SMALL_PENTEST_SERVER.
export default function getPentestServer() {
  const explicit = process.env.REACT_APP_SMALL_PENTEST_SERVER;
  const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://138.199.234.61:8080';
  const gatewayPrefix = process.env.REACT_APP_PENTEST_GATEWAY_PREFIX || '/api/pentest';

  if (explicit && explicit.trim() !== '') {
    return explicit.trim();
  }

  const base = (apiBase || '').replace(/\/+$/, '');
  let prefix = (gatewayPrefix || '').replace(/^\/+/, '/');
  if (!prefix.startsWith('/')) prefix = `/${prefix}`;

  // Safe join to avoid double "/api" when base ends with "/api" and prefix starts with "/api/"
  if (base.endsWith('/api') && prefix.startsWith('/api/')) {
    return `${base.slice(0, -4)}${prefix}`;
  }
  // If base ends with '/api' but prefix is a gateway like '/pentest/...', drop '/api' from base
  if (base.endsWith('/api') && !prefix.startsWith('/api')) {
    return `${base.slice(0, -4)}${prefix}`;
  }
  return `${base}${prefix}`;
}